import ConfirmationDialog from './ConfirmationDialog.vue'; // Adjust path if needed

// Create a container element for dialogs within the <v-app>
// This ensures dialogs are correctly styled and positioned
function setMountPoint() {
  let mountPoint = document.getElementById('dialog-helper-mount-point');
  if (!mountPoint) {
    mountPoint = document.createElement('div');
    mountPoint.setAttribute('id', 'dialog-helper-mount-point');
    const appElement = document.querySelector('[data-app="true"]');
    if (appElement) {
      appElement.appendChild(mountPoint);
    } else {
      console.warn('[DialogPlugin] Could not find <v-app data-app="true"> element. Dialogs may not render correctly.');
      document.body.appendChild(mountPoint); // Fallback to body
    }
  }
  return mountPoint;
}

/**
 * Reason for creating this, base $dialog.confirm on Vuetify Dialog, does not have full control on buttons
 */
const DialogPlugin = {
  install(VueInstance, options = {}) {
    // Ensure Vuetify instance is passed for proper styling/theming
    const vuetifyInstance = options.vuetify;
    if (!vuetifyInstance) {
      console.warn('[DialogPlugin] Vuetify instance is required. Pass it during plugin installation: Vue.use(DialogPlugin, { vuetify })');
      throw new Error('[DialogPlugin] Vuetify instance is required');
    }

    // Add $confirm method to Vue prototype
    VueInstance.prototype.$confirm = function(config) {
      // The calling component's context (`this`) is available here
      // Be mindful if you need `$t` or other context-specific things inside the config *actions*
      // It's generally better to resolve translations *before* calling $confirm

      return new Promise((resolve) => {
      // Create a Vue constructor for the dialog component
        const DialogComponent = VueInstance.extend({
          vuetify: vuetifyInstance, // Provide Vuetify instance to the component
          // parent: this, // Optionally link parent context, useful for $t sometimes but can be complex
          ...ConfirmationDialog // Spread the component definition
        });

        // Create an instance of the dialog component
        const instance = new DialogComponent({
          propsData: {
            ...config, // Pass user configuration as props
            resolve, // Pass the Promise's resolve function
          },
        });

        const mountPoint = setMountPoint(); // Ensure the mount point is set up

        // Mount the instance onto a new element within our mount point
        const instanceElement = document.createElement('div');
        mountPoint.appendChild(instanceElement);
        instance.$mount(instanceElement); // Mount and render the component

      // The component's `mounted` hook will make it visible
      // The component's internal logic handles resolution and destruction
      });
    };
  },
};

export default DialogPlugin;